import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InfoBubbleType } from '../info-bubble/info-bubble.model';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  // eslint-disable-next-line
  standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
  title: string | undefined;
  message: string | undefined;
  cancel: string | undefined;
  confirm: string | undefined;

  InfoBubbleType = InfoBubbleType;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  ngOnInit(): void {}
}

export interface ConfirmDialogData {
  message: string;
  title: string;
  warningMessage?: string;
  infoBubleWarningTitle?: string;
  infoBubleWarningMessage?: string;
  cancel?: string;
  confirm?: string;
}
